import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { HomeViewComponent } from './home/views/home-view/home-view.component';
import { featureFlagGuard } from './core/feature-flags';
import { downloadThenRedirect } from './shared/download-then-redirect.guard';

const routes: Routes = [
    {
        path: '',
        component: HomeViewComponent,
        pathMatch: 'full',
    },
    // the /sfcr-bericht path should download the
    // SFCR report document. The `downloadThenRedirect`
    // `CanActivateFn` takes care of the download, then
    // redirects to the home page. You still have to
    // set a component for the path, so we reuse the
    // `HomeViewComponent` here.
    {
        path: 'sfcr-bericht',
        component: HomeViewComponent,
        pathMatch: 'full',
        canActivate: [downloadThenRedirect('/assets/documents/SFCR_astra_Versicherung_20251231.pdf', '')],
    },
    // redirects for obsolete products:
    {
        path: 'produkte/schueler-kombischutz-m',
        redirectTo: '',
        pathMatch: 'full',
    },
    {
        path: 'produkte/schueler-haftpflicht-und-sachschadenversicherung',
        redirectTo: '',
        pathMatch: 'full',
    },
    // modules:
    {
        path: '',
        loadChildren: () => import('./public/public.module').then((m) => m.PublicModule),
    },
    {
        path: 'portal',
        loadChildren: () => import('./customer-portal/routes').then((m) => m.portalRoutes),
        canActivate: [featureFlagGuard(['portalMaintenanceMode'], false, ['/', 'under-construction'])],
    },
    {
        path: 'produkte',
        loadChildren: () => import('./order/order.module').then((m) => m.OrderModule),
        canActivate: [featureFlagGuard(['orderFormMaintenanceMode'], false, ['/', 'under-construction'])],
    },
    // redirects for adword campaign:
    {
        path: 'schueler/instrumenten-versicherung',
        redirectTo: 'produkte/schueler-musikinstrumenten-versicherung',
        pathMatch: 'full',
    },
    {
        path: 'schueler/fahrrad-versicherung',
        redirectTo: 'produkte/schueler-fahrrad-versicherung',
        pathMatch: 'full',
    },
    {
        path: 'schueler/nachhilfe-versicherung',
        redirectTo: 'produkte/nachhilfe-plus',
        pathMatch: 'full',
    },
    // general redirects:
    {
        path: '**',
        redirectTo: '',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            enableTracing: false,
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
        }),
    ],
})
export class AppRoutingModule {}

// All components routed via the (root) app router are declared here.
export const routingComponents = [];
